<template>
  <div :class="['documents-card medium-border-radius', type === 'success' && 'offwhite-bg']">
    <div
      :class="['card-header p-2 text-center mb-2 medium-border-radius', type === 'danger' && 'danger-bg']">
      <h5 class="text-bold" v-if="type === 'success'">DOCUMENTOS ENVIADOS</h5>
      <h5 class="text-bold text-white" v-if="type === 'danger'">DOCUMENTOS NÃO ENVIADOS</h5>
      <p v-if="type === 'success'">Total de {{ docs.length }} documentos enviados</p>
      <p v-if="type === 'danger'" class="text-white">Faltam
        {{ missingDocs.filter((doc) => doc.status === 'missing').length }} documentos
        obrigatórios</p>
    </div>

    <div class="card-content ph-2" >
      <ul class="files-list columns gap2" v-if="type === 'success' && docs.length > 0">
        <li class="flex ai-c jc-sb fgap2 pb-2 span-12" v-for="(doc, index) in docs" :key="index">
          <div class="flex ai-c fgap1">
            <div class="flex ai-c fgap1">
              <span v-if="verifyDocIcon(doc.originalFilename) === 'pdf'">
                <img src="@/assets/img/pdf.png" width="60px" height="60px" alt="PDF">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'xml'">
                <img src="@/assets/img/xml.png" width="60px" height="60px" alt="XML">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'png'">
                <img src="@/assets/img/png.png" width="60px" height="60px" alt="PNG">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'jpeg'">
                <img src="@/assets/img/jpg.png" width="60px" height="60px" alt="JPEG">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'jpg'">
                <img src="@/assets/img/jpg.png" width="60px" height="60px" alt="JPG">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'xlsx'">
                <img src="@/assets/img/xls.png" width="60px" height="60px" alt="XLSX">
              </span>
              <span v-if="verifyDocIcon(doc.originalFilename) === 'general'">
                <img src="@/assets/img/archive.png" width="60px" height="60px" alt="ARQUIVO">
              </span>
              <div>
                <p class="text-bold">
                  {{ doc.description }}
                  <small class="text-thin"> - {{ doc.documentTypeName }} </small>
                  <span class="danger-bg" v-if="doc.new === true && !doc.currentUserHasDownloaded" style="border-radius: var(--small-border-radius); padding: 0.05rem 0.5rem; font-size: 0.75rem; color: var(--white-color);">NOVO</span>
                </p>
                <p class="doc-description text-md">{{ doc.originalFilename }} </p>
                <p class="doc-user"> Enviando em {{doc.created | moment("DD/MM/YY à\\s H:mm:ss")}} por {{ doc.createdBy }} </p>
                <p class="doc-user" v-if="doc.currentUserHasDownloaded"> Último download em {{doc.lastDownloadAt | moment("DD/MM/YY à\\s H:mm:ss")}} por {{ doc.lastDownloadByUserName }} </p>
              </div>
            </div>
          </div>

          <div class="flex gap1">
            <button type="button"
                    @click.prevent="() => downloadDocument(doc.id, doc.originalFilename, doc)"
                    class="btn solid primary medium text-thin">DOWNLOAD
            </button>
          </div>
        </li>
      </ul>

      <ul class="files-list missing columns gap2" v-if="type === 'danger'">
        <li class="flex ai-c fgap2 pb-2 span-6" v-for="(doc, index) in missingDocs" :key="index">
          <PdfIcon style="color: var(--danger-color);" v-if="doc.status === 'missing'"/>
          <PdfIcon style="color: var(--light-text-color);" v-if="doc.status === 'sended'"/>
          <p class="text-bold text-md">{{ doc.title }}</p>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

import { mapState } from 'vuex';
import {
  PdfIcon,
} from '@/components/Icons';

export default {
  name: 'DocumentsCard',
  components: {
    // Icons
    PdfIcon,
  },
  computed: {
    ...mapState('process', ['processes']),
  },
  methods: {
    async downloadDocument(docId, originalFilename, doc) {
      try {
        const response = await api.get(`/api/public/partner/processes/${this.process.id}/documents/${docId}/download`, {
          responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', originalFilename);
        document.body.appendChild(link);
        link.click();
        this.$emit('refresh-documents');
        if (doc.new === true && !doc.currentUserHasDownloaded) {
          const newStateProcesses = this.processes.map((proc) => {
            if (Number(proc.id) === Number(this.process.id)) {
              return {
                ...proc,
                quantityNewDocumentsCustomBroker: Math.max(0, (proc.quantityNewDocumentsCustomBroker || 0) - 1),
              };
            }
            return proc;
          });
          this.$store.commit('process/UPDATE_PROCESSES', newStateProcesses);
        }
      } catch (err) {
        this.$toast.error('Não foi possível fazer o download do documento!');
      }
    },
    async deleteDocument(doc) {
      this.$modal.show({
        title: 'Excluir Documento',
        text: `Você tem certeza que deseja excluir o documento ${doc.description} documento?`,
        cancelText: 'Não',
        confirmText: 'Sim',
        onConfirm: async () => {
          try {
            const response = await api.delete(`/api/public/partner/processes/${this.process.id}/documents/${doc.id}`);
            if (response) {
              this.$toast.success(`O documento ${doc.description} foi excluído com sucesso!`);
              this.$emit('refresh-documents');
            }
          } catch (err) {
            this.$toast.error('Não foi possível excluir o documento!');
          }
        },
      });
    },
    verifyDocIcon(originalFilename) {
      const reg = [
        {
          type: 'pdf',
          reg: new RegExp('.pdf', 'gi'),
        },
        {
          type: 'jpeg',
          reg: new RegExp('.jpeg', 'gi'),
        },
        {
          type: 'jpg',
          reg: new RegExp('.jpg', 'gi'),
        },
        {
          type: 'png',
          reg: new RegExp('.png', 'gi'),
        },
        {
          type: 'xml',
          reg: new RegExp('.xml', 'gi'),
        },
        {
          type: 'xlsx',
          reg: new RegExp('.xlsx', 'gi'),
        },
      ];

      let type = 'general';

      reg.forEach((r) => {
        if (r.reg.test(originalFilename)) {
          type = r.type;
        }
      });

      return type;
    },
  },
  props: {
    type: {
      type: String,
      default: 'success',
    },
    docs: {
      type: Array,
      default: () => [],
    },
    missingDocs: {
      type: Array,
      default: () => [],
    },
    process: {
      type: Object,
      default: () => {
      },
    },
  },
};
</script>

<style scoped>
.files-list:not(.missing) li:not(:last-of-type) {
  border-bottom: var(--input-border);
}

.files-list.missing li {
  border-bottom: var(--input-border);
}

.doc-description {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.doc-user {
  font-size: 0.85rem;
}
</style>
